// src/services/workOrderServices.js
import api from './api';
import { downloadPdfFromResponse } from '../utils/pdfHelpers';

/* ---------------------------------------
   ERROR HANDLER
--------------------------------------- */
const handleError = (error, context = 'Work order error') => {
  console.error(
    `❌ ${context}:`,
    error.response?.data || error.message || error
  );
  throw error;
};

/* ---------------------------------------
   WORK ORDERS
--------------------------------------- */

// Fetch all Work Orders
export const fetchWorkOrders = async (source = '') => {
  try {
    const res = await api.get('/work-orders', { params: source ? { source } : undefined });
    return res.data;
  } catch (error) {
    handleError(error, 'Failed to fetch work orders');
  }
};

// Fetch Work Order by ID
export const fetchWorkOrderById = async (id) => {
  try {
    const res = await api.get(`/work-orders/${id}`);
    return res.data;
  } catch (error) {
    handleError(error, `Failed to fetch work order ${id}`);
  }
};

// Update Work Order Status
export const updateWorkOrderStatus = async (id, status) => {
  try {
    const res = await api.put(
      `/work-orders/${id}/status`,
      { status }
    );
    return res.data;
  } catch (error) {
    handleError(error, `Failed to update status for work order ${id}`);
  }
};

// Generate / Download Work Order PDF
export const generateWorkOrderPdf = async (workOrderId) => {
  if (!workOrderId) {
    throw new Error('Work Order ID is required');
  }

  try {
    const res = await api.get(
      `/work-orders/${workOrderId}/pdf`,
      {
        responseType: 'blob', // 🔥 REQUIRED
      }
    );

    await downloadPdfFromResponse(
      res,
      `work-order-${workOrderId}.pdf`,
      'Failed to download work order PDF'
    );

  } catch (error) {
    handleError(error, 'Failed to generate work order PDF');
  }
};
